import { Cellphone } from "./types"

export const formatCellphone = (cellphone: Cellphone) => {
  if (cellphone?.ddd && cellphone?.number)
    return `(${cellphone.ddd}) ${cellphone.number.replace(/(\d{4,5})(\d{4})/, '$1-$2')}`
  else return ''
}